export const NBA_SPLASH_MARKETING_PREFERENCES_OFFER_ID =
  '/DigitalNBAs/BPI/MrktPreferencesWebMob/VM/IV015S1';
